export const mapBlockTemplate = {
    'CUSTOMER_NAME': {
        component: 'UpdateCustomerName'
    },
    'CUSTOMER_CORP_NAME': {
        component: 'UpdateCustomerName'
    },
    'CUSTOMER_PHONE': {
        component: 'UpdatePhone'
    },
    'CUSTOMER_MAIN_MAIL': {
        component: 'UpdateMail'
    },
    'CUSTOMER_SELF_ASSET': {
        component: 'UpdateSelfAsset'
    },
    'CUSTOMER_FX_INVEST': {
        component: 'UpdateFxInvestPurpose'
    },
    'CUSTOMER_PASSWORD': {
        component: 'UpdatePwd'
    },
    'SECOND_PASSWORD': {
        component: 'UpdateSecondPwd'
    },
    'CUSTOMER_BO_INVEST': {
        component: 'UpdateBoInvestPurpose'
    },
    'CUSTOMER_BO_LOSS_MAX': {
        component: 'UpdateBoMaxLossAmount'
    },
    'CUSTOMER_CRYPT_INVEST': {
        component: 'UpdateCryptoInvestPurpose'
    },
    'MY_NUMBER_UPLOAD': {
        component: 'UpdateMyNumber'
    },
    'CUSTOMER_ADDRESS': {
        component: 'UpdateCustomerAddress'
    },
    'CUSTOMER_FINANCIAL_INFO': {
        component: 'UpdateFinancialInfo'
    },
    'DOCUMENT_ID_UPLOAD': {
        component: 'UploadIdDocument'
    },
    'REGISTERED_PASSKEYS_BLOCK': {
        component: 'RegisteredPasskeys'
    },
}

export default {};
















